<template>
  <div class="">
    <div class="container mt-5 mb-5 rounded bg-danger p-2 text-center" v-if="computeUserAccess ">
      <h5 class="text-white" v-t="'tools.message.complete_profile_message.description'"></h5>
      <m-a :href="{name:'Profile'}">
        <span class="btn btn-primary rounded-pill" v-t="'tools.message.complete_profile_message.button'"></span>
      </m-a>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import mA from '../../Tags/A.vue'

export default defineComponent({
  name: "CompleteProfileMessage1",
  components: {mA},
  computed: {
    ...mapGetters({
      isAuthenticated: "User/isAuthenticated",
      profile: "User/getProfile"
    }),
    profileRequirementStatus() {
      return findAttributeOnSiteInfo('profile_fill_requirement')[0]
    },
    computeUserAccess() {
      if (this.profileRequirementStatus == 0) {
        return false
      }

      if (this.isAuthenticated && this.profile.profile_status == 0) {
        return true
      }

      return false


    }
  }
})
</script>


<style scoped>

</style>